<template>
    <iframe ref="frame" :src="src" width="100%" height="100%" frameborder="0"></iframe>
</template>

<script>
    export default {
        props: {
            src: String
        },
        methods: {
            receiveMessage (event) {
                try {
                    let data = JSON.parse(event.data)
                    if (data.key === 'browser' && this.$refs.frame.src === data.frame) {
                        this.$emit('action', data)
                    }
                } catch (e) {
                    // empty
                }
            }
        },
        mounted () {
            window.addEventListener('message', this.receiveMessage, false)
        },
        beforeDestroy () {
            window.removeEventListener('message', this.receiveMessage, false)
        }
    }
</script>